import { ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFeatureFlags } from "context/FeatureFlagsContext";
import { useUser } from "context/UserContext";
import {
  getAdminNavigationItems,
  getNonAdminNavigationItems,
} from "./useNavigationItems.utils";

export type TNavigationItem = {
  key: string;
  label: string;
  icon?: ReactElement;
  href: string;
  items?: TNavigationItem[];
  disabled?: boolean;
};

const useNavigationItems = () => {
  const userContext = useUser();
  const featureFlags = useFeatureFlags();

  const { t } = useTranslation("common", {
    keyPrefix: "navigation",
  });

  const accumulusAdminNavigationItems = useMemo(
    () => getAdminNavigationItems(t, userContext, featureFlags),
    [t, userContext, featureFlags],
  );

  const nonAdminNavigationItems = useMemo(
    () => getNonAdminNavigationItems(t, userContext, featureFlags),
    [t, userContext, featureFlags],
  );

  const navigationItems: TNavigationItem[] = [
    ...nonAdminNavigationItems,
    ...accumulusAdminNavigationItems,
  ];

  return navigationItems;
};

export default useNavigationItems;
